import {EntityAction, EntityCollectionServiceBase, EntityOp, QueryParams} from "@ngrx/data";
import {combineLatest, Observable} from "rxjs";
import {map} from "rxjs/operators";
import {Sort, UrlParameter} from "../../../shared/utils/url.builder";
import {Pageable} from "../../../shared/model/core/pageable.model";
import {HttpModelConverter} from "../converter/httpModel.converter";
import {DefaultDataservice} from "../../../store/core/dataservice/default.dataservice";

export abstract class EntityCollectionReadOnlyService<T, C extends HttpModelConverter<T>> {

    // readonly entities$: Observable<T[]>;
    readonly queryManyError$: Observable<EntityAction>;
    readonly loading$: Observable<boolean>;

    readonly entityCollectionServiceBase: EntityCollectionServiceBase<T>;
    readonly dataService: DefaultDataservice<T>;
    readonly serviceName: string;
    readonly converter: C;
    readonly entityActions$: Observable<EntityAction>;
    readonly entityName;

    protected constructor(serviceName: string,
                          entityCollectionServiceBase: EntityCollectionServiceBase<T>,
                          dataService: DefaultDataservice<T>,
                          converter: C) {
        this.serviceName = serviceName + '_' + Math.random().toString(36).substr(2, 9);
        this.entityCollectionServiceBase = entityCollectionServiceBase;
        this.dataService = dataService;
        this.converter = converter;
        this.entityActions$ =this.entityCollectionServiceBase.entityActions$;
        this.entityName = this.entityCollectionServiceBase.entityName;

        /* this.entities$ = this.entityCollectionServiceBase.entities$.pipe(
            map(value => this.converter.convertFromArray(value))); */

        this.loading$ = combineLatest([
            this.entityCollectionServiceBase.loading$,
            this.entityCollectionServiceBase.entityActions$
        ]).pipe(
            map(([loading, action]) => action.payload.tag === this.serviceName &&  action.payload.entityOp === EntityOp.QUERY_MANY && loading === true));


        this.queryManyError$ = this.entityCollectionServiceBase.entityActions$.pipe(
            map(error => error.payload.tag === this.serviceName && error.payload.entityOp === EntityOp.QUERY_MANY_ERROR ? error : undefined)
        );

        // this.loading$ = this.entityCollectionServiceBase.loading$;
    }

    protected buildQueryParams(pageable: Pageable, parameters: UrlParameter[], sort: Sort): QueryParams {
        // // console.logByType['parameters', parameters]);
        let queryParams = {};
        if (pageable) {
            queryParams['page'] = pageable.pageNumber;
            queryParams['size'] = pageable.pageSize;
        }

        if (parameters) {
            parameters.forEach(urlParameter => queryParams[urlParameter._name] = urlParameter.valueParameter());
        }

        if (sort) {
            queryParams['sortBy'] = sort._name + ':' + sort._order
        }
        return queryParams;
    }
}
